<ion-fab horizontal="end" slot="fixed" vertical="bottom">
  <ion-fab-button
    (click)="dismissToast()"
    class="cmn-fab-contact__main-button"
    aria-label="Contact"
    color="primary"
  >
    <fa-icon aria-hidden="true" icon="comment-dots" size="2x" />
  </ion-fab-button>
  <ion-fab-list side="top">
    <ion-fab-button
      [href]="facebookMessengerLink()"
      class="cmn-fab-contact__facebook-messenger-button"
      aria-label="Facebook-messenger"
      target="_blank"
    >
      <fa-icon
        [icon]="['fab', 'facebook-messenger']"
        aria-hidden="true"
        size="2x"
      />
    </ion-fab-button>
    <ion-fab-button
      [href]="instagramDirectMessageLink()"
      class="cmn-fab-contact__instagram-button"
      aria-label="Instagram"
      target="_blank"
    >
      <fa-icon [icon]="['fab', 'instagram']" aria-hidden="true" size="2x" />
    </ion-fab-button>
    <ion-fab-button
      [href]="whatsAppLink()"
      class="cmn-fab-contact__whattsapp-button"
      aria-label="WhatsApp"
      target="_blank"
    >
      <fa-icon [icon]="['fab', 'whatsapp']" aria-hidden="true" size="2x" />
    </ion-fab-button>
  </ion-fab-list>
  <ion-fab-list side="start">
    <ion-fab-button
      [href]="'mailto:' + mailLink()"
      aria-label="Email"
      color="dark"
    >
      <fa-icon aria-hidden="true" icon="envelope" />
    </ion-fab-button>
  </ion-fab-list>
</ion-fab>
<ion-toast
  [isOpen]="isToastOpen"
  (click)="toast.dismiss()"
  (didDismiss)="isToastOpen = false"
  (ionToastDidPresent)="shadowBottom()"
  class="cmn-fab-contact__toast"
  #toast
  duration="5000"
  message="Bug ou coquille à signaler ? C'est ici"
/>
